import { gql } from '@apollo/client';
import { POSITION_DETAIL_FIELDS } from '../../fragments';
import { ApolloClientFunctionProps } from '../../utils';
import { PositionType } from '../../../types';

export const GET_POSITIONS = gql`
  ${POSITION_DETAIL_FIELDS}
  query getPositions {
    positions {
      ...PositionDetailFields
    }
  }
`;

/**
 * Get Positions
 *
 * @returns PositionType[]
 */
export function getPositions({ client }: ApolloClientFunctionProps) {
  return client?.watchQuery<{ positions: PositionType[] }>({
    query: GET_POSITIONS,
  });
}
